import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import Select from '../Select';
import { months, years } from './constant';
var Header = (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleYearChange = function (year) {
            _this.props.onYearChange(Number(year));
        };
        _this.handleMonthChange = function (month) {
            _this.props.onMonthChange(Number(month));
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, showMonth = _a.showMonth, selectedMonth = _a.selectedMonth, selectedYear = _a.selectedYear, onNext = _a.onNext, onPrev = _a.onPrev;
            var cls = classNames(prefixCls, className);
            return (h("div", { className: cls, style: style },
                h("div", { className: classNames(prefixCls + "-select-container") },
                    h(Select, { className: classNames(prefixCls + "-select", prefixCls + "-year"), listClassName: classNames(prefixCls + "-select-item-list"), value: String(selectedYear), onChange: _this.handleYearChange }, years.map(function (year) {
                        return h(Select.Option, { key: year, value: year, className: classNames(prefixCls + "-select-item") }, year);
                    })),
                    showMonth &&
                        h(Select, { className: classNames(prefixCls + "-select", prefixCls + "-month"), listClassName: classNames(prefixCls + "-select-item-list"), value: String(selectedMonth), onChange: _this.handleMonthChange }, months.map(function (month) {
                            return h(Select.Option, { key: month, value: month, className: classNames(prefixCls + "-select-item") },
                                month,
                                "\u6708");
                        }))),
                h("div", { className: classNames(prefixCls + "-page-button") },
                    h("div", { className: classNames(prefixCls + "-prev"), onClick: onPrev }),
                    h("div", { className: classNames(prefixCls + "-next"), onClick: onNext }))));
        };
        return _this;
    }
    Header.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Header;
}(React.Component));
export default Header;
Header.defaultProps = {
    prefixCls: 'dui-datepicker-header',
    showMonth: true,
};
